import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scripts.dealer-franchisee.quotes.views.FranchiseeQuoteItemsView.';
  public static readonly itemNumber = `${Id.prefix}itemNumber`;
  public static readonly image = `${Id.prefix}image`;
  public static readonly frameTitleAndDescription = `${Id.prefix}frameTitleAndDescription`;
  public static readonly frameTitle = `${Id.prefix}frameTitle`;
  public static readonly untitled = `${Id.prefix}untitled`;
  public static readonly options = `${Id.prefix}options`;
  public static readonly notesToClient = `${Id.prefix}notesToClient`;
  public static readonly notesToManufacturer = `${Id.prefix}notesToManufacturer`;
  public static readonly information = `${Id.prefix}information`;
  public static readonly supplierNote = `${Id.prefix}supplierNote`;
  public static readonly warning = `${Id.prefix}warning`;
  public static readonly criticalError = `${Id.prefix}criticalError`;
  public static readonly requireValidation = `${Id.prefix}requireValidation`;
  public static readonly dealerPriceAdjustment = `${Id.prefix}dealerPriceAdjustment`;
  public static readonly supplierPriceAdjustment = `${Id.prefix}supplierPriceAdjustment`;
  public static readonly noTax = `${Id.prefix}noTax`;
  public static readonly tags = `${Id.prefix}tags`;
  public static readonly qty = `${Id.prefix}qty`;
  public static readonly lastModified = `${Id.prefix}lastModified`;
  public static readonly extListPrice = `${Id.prefix}extListPrice`;
  public static readonly multiplier = `${Id.prefix}multiplier`;
  public static readonly supplierPriceAdj = `${Id.prefix}supplierPriceAdj`;
  public static readonly costPrice = `${Id.prefix}costPrice`;
  public static readonly dealerPriceAdj = `${Id.prefix}dealerPriceAdj`;
  public static readonly tax = `${Id.prefix}tax`;
  public static readonly sellingPrice = `${Id.prefix}sellingPrice`;
  public static readonly supplierReference = `${Id.prefix}supplierReference`;
  public static readonly supplierMustProvideReference = `${Id.prefix}supplierMustProvideReference`;
  public static readonly supplierIsOffline = `${Id.prefix}supplierIsOffline`;
  public static readonly noQuoteItemsInQuote = `${Id.prefix}noQuoteItemsInQuote`;
  public static readonly taxWithRate = `${Id.prefix}taxWithRate`;
  public static readonly taxWithPercentage = `${Id.prefix}taxWithPercentage`;
  public static readonly dealerTermsAndConditions = `${Id.prefix}dealerTermsAndConditions`;
  public static readonly dealerNameTermsAndConditions = `${Id.prefix}dealerNameTermsAndConditions`;
  public static readonly zeroRatedItems = `${Id.prefix}zeroRatedItems`;
  public static readonly taxedItems = `${Id.prefix}taxedItems`;
  public static readonly items = `${Id.prefix}items`;
  public static readonly priceAdjustment = `${Id.prefix}priceAdjustment`;
  public static readonly itemsTotal = `${Id.prefix}itemsTotal`;
  public static readonly quoteTotal = `${Id.prefix}quoteTotal`;
  public static readonly primaryBatchName = `${Id.prefix}primaryBatchName`;
  public static readonly groupTotal = `${Id.prefix}groupTotal`;
  public static readonly frames = `${Id.prefix}frames`;
  public static readonly showInternalView = `${Id.prefix}showInternalView`;
  public static readonly showClientFacingView = `${Id.prefix}showClientFacingView`;
  public static readonly bomView = `${Id.prefix}bomView`;
  public static readonly delete = `${Id.prefix}delete`;
  public static readonly undelete = `${Id.prefix}undelete`;
  public static readonly copy = `${Id.prefix}copy`;
  public static readonly edit = `${Id.prefix}edit`;
  public static readonly view = `${Id.prefix}view`;
  public static readonly pricing = `${Id.prefix}pricing`;
  public static readonly settings = `${Id.prefix}settings`;
  public static readonly pricingSummary = `${Id.prefix}pricingSummary`;
  public static readonly pageConfiguration = `${Id.prefix}pageConfiguration`;
  public static readonly tableConfiguration = `${Id.prefix}tableConfiguration`;
  public static readonly tooltipFrameConfiguration = `${Id.prefix}tooltipFrameConfiguration`;
  public static readonly tooltipPricing = `${Id.prefix}tooltipPricing`;
  public static readonly linkQuoteItemsToSupport = `${Id.prefix}linkQuoteItemsToSupport`;
  public static readonly linkQuoteItems = `${Id.prefix}linkQuoteItems`;
  public static readonly showOnlySelectedItems = `${Id.prefix}showOnlySelectedItems`;
  public static readonly hideDeletedItems = `${Id.prefix}hideDeletedItems`;
  public static readonly showDeletedItems = `${Id.prefix}showDeletedItems`;
  public static readonly fabricationStatusUpdated = `${Id.prefix}fabricationStatusUpdated`;
  public static readonly fabricationStatus = `${Id.prefix}fabricationStatus`;
  public static readonly readyForFabrication = `${Id.prefix}readyForFabrication`;
  public static readonly assignedToJob = `${Id.prefix}assignedToJob`;
  public static readonly inProduction = `${Id.prefix}inProduction`;
  public static readonly readyForDelivery = `${Id.prefix}readyForDelivery`;
  public static readonly delivered = `${Id.prefix}delivered`;
  public static readonly invalidFrameData = `${Id.prefix}invalidFrameData`;
  public static readonly createGroup = `${Id.prefix}createGroup`;
  public static readonly editGroup = `${Id.prefix}editGroup`;
  public static readonly viewGroup = `${Id.prefix}viewGroup`;
  public static readonly deleteGroup = `${Id.prefix}deleteGroup`;
  public static readonly deleteGroupConfirm = `${Id.prefix}deleteGroupConfirm`;
  public static readonly moveToGroup = `${Id.prefix}moveToGroup`;
  public static readonly removeFromGroup = `${Id.prefix}removeFromGroup`;
  public static readonly newGroup = `${Id.prefix}newGroup`;
  public static readonly moveUp = `${Id.prefix}moveUp`;
  public static readonly moveDown = `${Id.prefix}moveDown`;
  public static readonly groupItemCount = `${Id.prefix}groupItemCount`;
  public static readonly groupItemCountOne = `${Id.prefix}groupItemCountOne`;
  public static readonly groupItemCountSelectorTooltip = `${Id.prefix}groupItemCountSelectorTooltip`;
  public static readonly defaultBatch = `${Id.prefix}defaultBatch`;
  public static readonly defaultBatchTooltip = `${Id.prefix}defaultBatchTooltip`;
  public static readonly excludedFromPricing = `${Id.prefix}excludedFromPricing`;
  public static readonly groupName = `${Id.prefix}groupName`;
  public static readonly excludeFromPricing = `${Id.prefix}excludeFromPricing`;
  public static readonly excludeFromPricingTooltip = `${Id.prefix}excludeFromPricingTooltip`;
  public static readonly groupDefaultName = `${Id.prefix}groupDefaultName`;
  public static readonly groupNameRequired = `${Id.prefix}groupNameRequired`;
  public static readonly batchDeliveryDate = `${Id.prefix}batchDeliveryDate`;
  public static readonly batchDeliveryDateTooltip = `${Id.prefix}batchDeliveryDateTooltip`;
  public static readonly batchCustomerRef = `${Id.prefix}batchCustomerRef`;
  public static readonly batchComment = `${Id.prefix}batchComment`;
  public static readonly pricingUnavailable = `${Id.prefix}pricingUnavailable`;
  public static readonly pricingUnavailableTooltip = `${Id.prefix}pricingUnavailableTooltip`;
}

export class LangFranchiseeQuoteItemsView {
  private constructor() {}

  public static itemNumber(): string {
    return interpolate(Id.itemNumber);
  }

  public static invalidFrameData(): string {
    return interpolate(Id.invalidFrameData);
  }
  public static image(): string {
    return interpolate(Id.image);
  }

  public static frameTitleAndDescription(): string {
    return interpolate(Id.frameTitleAndDescription);
  }

  public static frameTitle(): string {
    return interpolate(Id.frameTitle);
  }

  public static untitled(): string {
    return interpolate(Id.untitled);
  }

  public static options(): string {
    return interpolate(Id.options);
  }

  public static notesToClient(): string {
    return interpolate(Id.notesToClient);
  }

  public static notesToManufacturer(): string {
    return interpolate(Id.notesToManufacturer);
  }

  public static information(): string {
    return interpolate(Id.information);
  }

  public static supplierNote(): string {
    return interpolate(Id.supplierNote);
  }

  public static warning(): string {
    return interpolate(Id.warning);
  }

  public static criticalError(): string {
    return interpolate(Id.criticalError);
  }

  public static requireValidation(): string {
    return interpolate(Id.requireValidation);
  }

  public static dealerPriceAdjustment(): string {
    return interpolate(Id.dealerPriceAdjustment);
  }

  public static supplierPriceAdjustment(): string {
    return interpolate(Id.supplierPriceAdjustment);
  }

  public static noTax(): string {
    return interpolate(Id.noTax);
  }

  public static tags(): string {
    return interpolate(Id.tags);
  }

  public static qty(): string {
    return interpolate(Id.qty);
  }

  public static lastModified(): string {
    return interpolate(Id.lastModified);
  }

  public static extListPrice(): string {
    return interpolate(Id.extListPrice);
  }

  public static multiplier(): string {
    return interpolate(Id.multiplier);
  }

  public static supplierPriceAdj(): string {
    return interpolate(Id.supplierPriceAdj);
  }

  public static costPrice(): string {
    return interpolate(Id.costPrice);
  }

  public static dealerPriceAdj(): string {
    return interpolate(Id.dealerPriceAdj);
  }

  public static tax(): string {
    return interpolate(Id.tax);
  }

  public static sellingPrice(): string {
    return interpolate(Id.sellingPrice);
  }

  public static supplierReference(): string {
    return interpolate(Id.supplierReference);
  }

  public static supplierMustProvideReference(): string {
    return interpolate(Id.supplierMustProvideReference);
  }

  public static supplierIsOffline(): string {
    return interpolate(Id.supplierIsOffline);
  }

  public static noQuoteItemsInQuote(): string {
    return interpolate(Id.noQuoteItemsInQuote);
  }

  public static taxWithRate(params: { taxName: string; taxRate: number }): string {
    return interpolate(Id.taxWithRate, params);
  }

  public static taxWithPercentage(params: { percentage: string }): string {
    return interpolate(Id.taxWithPercentage, params);
  }

  public static dealerTermsAndConditions(): string {
    return interpolate(Id.dealerTermsAndConditions);
  }

  public static dealerNameTermsAndConditions(params: { dealerName: string }): string {
    return interpolate(Id.dealerNameTermsAndConditions, params);
  }

  public static zeroRatedItems(): string {
    return interpolate(Id.zeroRatedItems);
  }

  public static taxedItems(): string {
    return interpolate(Id.taxedItems);
  }

  public static items(): string {
    return interpolate(Id.items);
  }

  public static priceAdjustment(): string {
    return interpolate(Id.priceAdjustment);
  }

  public static itemsTotal(): string {
    return interpolate(Id.itemsTotal);
  }

  public static quoteTotal(): string {
    return interpolate(Id.quoteTotal);
  }

  public static primaryBatchName(): string {
    return interpolate(Id.primaryBatchName);
  }
  public static groupTotal(): string {
    return interpolate(Id.groupTotal);
  }

  public static frames(): string {
    return interpolate(Id.frames);
  }

  public static showInternalView(): string {
    return interpolate(Id.showInternalView);
  }

  public static showClientFacingView(): string {
    return interpolate(Id.showClientFacingView);
  }

  public static bomView(): string {
    return interpolate(Id.bomView);
  }

  public static delete(): string {
    return interpolate(Id.delete);
  }
  public static undelete(): string {
    return interpolate(Id.undelete);
  }

  public static copy(): string {
    return interpolate(Id.copy);
  }

  public static edit(): string {
    return interpolate(Id.edit);
  }

  public static view(): string {
    return interpolate(Id.view);
  }

  public static pricing(): string {
    return interpolate(Id.pricing);
  }

  public static settings(): string {
    return interpolate(Id.settings);
  }

  public static pricingSummary(): string {
    return interpolate(Id.pricingSummary);
  }

  public static pageConfiguration(): string {
    return interpolate(Id.pageConfiguration);
  }

  public static tableConfiguration(): string {
    return interpolate(Id.tableConfiguration);
  }

  public static tooltipFrameConfiguration(): string {
    return interpolate(Id.tooltipFrameConfiguration);
  }

  public static tooltipPricing(): string {
    return interpolate(Id.tooltipPricing);
  }

  public static linkQuoteItemsToSupport(): string {
    return interpolate(Id.linkQuoteItemsToSupport);
  }

  public static linkQuoteItems(): string {
    return interpolate(Id.linkQuoteItems);
  }

  public static showOnlySelectedItems(): string {
    return interpolate(Id.showOnlySelectedItems);
  }

  public static hideDeletedItems(): string {
    return interpolate(Id.hideDeletedItems);
  }

  public static showDeletedItems(): string {
    return interpolate(Id.showDeletedItems);
  }

  public static fabricationStatusUpdated(): string {
    return interpolate(Id.fabricationStatusUpdated);
  }

  public static fabricationStatus(): string {
    return interpolate(Id.fabricationStatus);
  }

  public static readyForFabrication(): string {
    return interpolate(Id.readyForFabrication);
  }

  public static assignedToJob(params: { jobNumber: string }): string {
    return interpolate(Id.assignedToJob, params);
  }

  public static inProduction(): string {
    return interpolate(Id.inProduction);
  }

  public static readyForDelivery(): string {
    return interpolate(Id.readyForDelivery);
  }

  public static delivered(): string {
    return interpolate(Id.delivered);
  }

  public static createGroup(): string {
    return interpolate(Id.createGroup);
  }

  public static editGroup(): string {
    return interpolate(Id.editGroup);
  }
  public static viewGroup(): string {
    return interpolate(Id.viewGroup);
  }

  public static deleteGroup(): string {
    return interpolate(Id.deleteGroup);
  }

  public static deleteGroupConfirm(params: { name: string }): string {
    return interpolate(Id.deleteGroupConfirm, params);
  }

  public static moveToGroup(): string {
    return interpolate(Id.moveToGroup);
  }

  public static removeFromGroup(): string {
    return interpolate(Id.removeFromGroup);
  }

  public static newGroup(): string {
    return interpolate(Id.newGroup);
  }

  public static moveUp(): string {
    return interpolate(Id.moveUp);
  }

  public static moveDown(): string {
    return interpolate(Id.moveDown);
  }

  public static groupItemCount(params: { count: number }): string {
    return params.count === 1 ? interpolate(Id.groupItemCountOne, params) : interpolate(Id.groupItemCount, params);
  }

  public static groupItemCountSelectorTooltip(): string {
    return interpolate(Id.groupItemCountSelectorTooltip);
  }

  public static defaultBatch(): string {
    return interpolate(Id.defaultBatch);
  }

  public static defaultBatchTooltip(): string {
    return interpolate(Id.defaultBatchTooltip);
  }

  public static excludedFromPricing(): string {
    return interpolate(Id.excludedFromPricing);
  }

  public static groupName(): string {
    return interpolate(Id.groupName);
  }

  public static excludeFromPricing(): string {
    return interpolate(Id.excludeFromPricing);
  }

  public static excludeFromPricingTooltip(): string {
    return interpolate(Id.excludeFromPricingTooltip);
  }

  public static groupDefaultName(params: { number: number }): string {
    return interpolate(Id.groupDefaultName, params);
  }

  public static groupNameRequired(): string {
    return interpolate(Id.groupNameRequired);
  }

  public static batchDeliveryDate(): string {
    return interpolate(Id.batchDeliveryDate);
  }

  public static batchDeliveryDateTooltip(): string {
    return interpolate(Id.batchDeliveryDateTooltip);
  }

  public static batchCustomerRef(): string {
    return interpolate(Id.batchCustomerRef);
  }

  public static batchComment(): string {
    return interpolate(Id.batchComment);
  }

  public static pricingUnavailable(): string {
    return interpolate(Id.pricingUnavailable);
  }

  public static pricingUnavailableTooltip(): string {
    return interpolate(Id.pricingUnavailableTooltip);
  }
}

export class FranchiseeQuoteItemsViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.itemNumber, 'Item #', 'Column: Item number');
    register.add(Id.image, 'Image', 'Column: Image');
    register.add(
      Id.frameTitleAndDescription,
      "{{glossary 'frame-title'}} and Description",
      'Column: Frame title and description'
    );
    register.add(Id.frameTitle, "{{glossary 'frame-title'}}", 'Label: Frame title');
    register.add(Id.untitled, 'Untitled', 'Label: Untitled');
    register.add(Id.options, 'Options', 'Column: Options');
    register.add(Id.notesToClient, "Notes to {{glossary 'client'}}", 'Tooltip: Notes to client');
    register.add(Id.notesToManufacturer, 'Notes to Manufacturer', 'Tooltip: Notes to manufacturer');
    register.add(Id.information, 'Information', 'Tooltip: Information');
    register.add(Id.supplierNote, 'Supplier Note', 'Tooltip: Supplier note');
    register.add(Id.warning, 'Warning', 'Tooltip: Warning');
    register.add(Id.criticalError, 'Critical Error', 'Tooltip: Critical error');
    register.add(Id.requireValidation, 'Require Validation', 'Tooltip: Require validation');
    register.add(Id.dealerPriceAdjustment, 'Dealer Price Adjustment', 'Tooltip: Dealer price adjustment');
    register.add(Id.supplierPriceAdjustment, 'Supplier Price Adjustment', 'Tooltip: Supplier price adjustment');
    register.add(Id.noTax, 'No Tax', 'Tooltip: No tax');
    register.add(Id.tags, 'Tags', 'Column: Tags');
    register.add(Id.qty, 'Qty', 'Column: Quantity');
    register.add(Id.lastModified, 'Last Modified', 'Column: Last modified');
    register.add(Id.extListPrice, 'Ext. List Price', 'Column: Extended list price');
    register.add(Id.multiplier, 'Multi.', 'Column: Multiplier');
    register.add(Id.supplierPriceAdj, 'Supplier Price Adj.', 'Column: Supplier price adjustment');
    register.add(Id.costPrice, 'Cost Price', 'Column: Cost price');
    register.add(Id.dealerPriceAdj, 'Dealer Price Adj.', 'Column: Dealer price adjustment');
    register.add(Id.tax, 'Tax', 'Column: Tax');
    register.add(Id.sellingPrice, 'Selling Price', 'Column: Selling price');
    register.add(Id.supplierReference, "{{glossary 'supplier'}} Reference", 'Warning: Supplier reference');
    register.add(
      Id.supplierMustProvideReference,
      "The {{glossary 'supplier'}} must provide a reference",
      'Warning: Supplier must provide reference'
    );
    register.add(Id.supplierIsOffline, "{{glossary 'supplier'}} is OFFLINE", 'Warning: Supplier is offline');
    register.add(
      Id.noQuoteItemsInQuote,
      "There are no {{glossary 'quote-item:plural'}} in this {{glossary 'quote'}}. A blank {{glossary 'quote'}} will not be issued to the {{glossary 'client'}}.",
      'Validation: No quote items in quote'
    );
    register.add(Id.taxWithRate, '{{taxName}} {{taxRate}}%', 'Tax label with name and rate');
    register.add(Id.taxWithPercentage, "{{glossary 'tax'}} ({{percentage}}%)", 'Tax label with percentage');
    register.add(Id.dealerTermsAndConditions, 'Dealer Terms and Conditions', 'Label: Dealer terms and conditions');
    register.add(
      Id.dealerNameTermsAndConditions,
      '{{dealerName}} Terms and Conditions',
      'Label: Dealer name terms and conditions'
    );
    register.add(Id.zeroRatedItems, 'Zero Rated Items', 'Label: Zero rated items');
    register.add(Id.taxedItems, 'Taxed Items', 'Label: Taxed items');
    register.add(Id.items, 'Items', 'Label: Items');
    register.add(Id.priceAdjustment, 'Price Adjustment', 'Label: Price adjustment');
    register.add(Id.itemsTotal, 'Items Total', 'Label: Items total');
    register.add(Id.quoteTotal, "{{glossary 'quote'}} Total", 'Label: Quote total');
    register.add(
      Id.primaryBatchName,
      'All Items',
      'Default name of the primary catch-all delivery batch, auto-created with the first batch'
    );
    register.add(Id.groupTotal, "{{glossary 'quote-batch'}} Total", 'Label: Group total');
    register.add(Id.frames, "{{glossary 'frame:plural'}}", 'Header: Frames');
    register.add(Id.showInternalView, 'Show Internal View', 'Menu: Show internal view');
    register.add(Id.showClientFacingView, 'Show Client Facing View', 'Menu: Show client facing view');
    register.add(Id.bomView, 'Bom View', 'Menu: Bom View');
    register.add(Id.delete, 'Delete', 'Menu: Delete');
    register.add(Id.undelete, 'Restore', 'Menu: Restore (undelete) a deleted quote item');
    register.add(Id.copy, 'Copy', 'Menu: Copy');
    register.add(Id.edit, 'Edit', 'Menu: Edit');
    register.add(Id.view, 'View', 'Menu: View');
    register.add(Id.pricing, 'Pricing', 'Menu: Pricing');
    register.add(Id.settings, 'Settings', 'Button: Quote items settings menu');
    register.add(Id.pricingSummary, 'Pricing Summary', 'Button/drawer: Pricing summary');
    register.add(Id.pageConfiguration, 'Page Configuration', 'Label: Page configuration');
    register.add(Id.tableConfiguration, 'Table Configuration', 'Label: Table configuration');
    register.add(Id.tooltipFrameConfiguration, 'Frame Configuration', 'Tooltip section: Frame configuration');
    register.add(Id.tooltipPricing, 'Pricing', 'Tooltip section: Pricing');
    register.add(
      Id.linkQuoteItemsToSupport,
      "Link {{glossary 'quote-item:plural'}} To {{glossary 'support-request'}}",
      'Modal title: Link quote items to support request'
    );
    register.add(Id.linkQuoteItems, "Link {{glossary 'quote-item:plural'}}", 'Button: Link quote items');
    register.add(
      Id.showOnlySelectedItems,
      "Show Only Selected {{glossary 'quote-item:plural'}}",
      'Toggle: Show only selected quote items'
    );
    register.add(
      Id.hideDeletedItems,
      "Hide Deleted {{glossary 'quote-item:plural'}}",
      'Toggle: Hide deleted quote items'
    );
    register.add(
      Id.showDeletedItems,
      "Show Deleted {{glossary 'quote-item:plural'}}",
      'Toggle: Show deleted quote items'
    );
    register.add(
      Id.fabricationStatusUpdated,
      'Fabrication status updated.',
      'Toast: Fabrication status updated via SSE'
    );
    register.add(Id.fabricationStatus, 'Fabrication Status', 'Column: Fabrication status');
    register.add(Id.readyForFabrication, 'Ready for Fabrication', 'Badge: Ready for fabrication');
    register.add(Id.assignedToJob, 'Assigned to Job #{{jobNumber}}', 'Badge: Assigned to fabrication job number');
    register.add(Id.inProduction, 'In Production', 'Badge: In production');
    register.add(Id.readyForDelivery, 'Ready for Delivery', 'Badge: Ready for delivery');
    register.add(Id.delivered, 'Delivered', 'Badge: Delivered');
    register.add(
      Id.invalidFrameData,
      "Invalid {{glossary 'frame'}} Data. This was corrupted and cannot be fixed ",
      'Error: Invalid frame data'
    );
    register.add(Id.createGroup, "Create {{glossary 'quote-batch'}}", 'Button: Create a quote item group');
    register.add(Id.editGroup, "Edit {{glossary 'quote-batch'}}", 'Menu: Edit quote item group attributes');
    register.add(
      Id.viewGroup,
      "View {{glossary 'quote-batch'}}",
      'Menu/title: View quote item group attributes (read-only)'
    );
    register.add(Id.deleteGroup, "Delete {{glossary 'quote-batch'}}", 'Menu: Delete quote item group');
    register.add(
      Id.deleteGroupConfirm,
      "Delete {{glossary 'quote-batch'}} \"{{name}}\"? Its {{glossary 'quote-item:plural'}} will move to the default {{glossary 'quote-batch'}}, not be deleted.",
      'Confirmation: Delete quote item group'
    );
    register.add(Id.moveToGroup, "Move to {{glossary 'quote-batch'}}", 'Menu: Move quote item to a group');
    register.add(
      Id.removeFromGroup,
      "Remove from {{glossary 'quote-batch'}}",
      'Menu: Remove quote item from its group'
    );
    register.add(Id.newGroup, "New {{glossary 'quote-batch'}}...", 'Menu: Create a new group for this quote item');
    register.add(Id.moveUp, 'Move Up', 'Menu: Move group up');
    register.add(Id.moveDown, 'Move Down', 'Menu: Move group down');
    register.add(Id.groupItemCount, '{{count}} items', 'Badge: Number of items in a group (plural)');
    register.add(Id.groupItemCountOne, '{{count}} item', 'Badge: Number of items in a group (singular)');
    register.add(
      Id.groupItemCountSelectorTooltip,
      "This count is for the whole {{glossary 'quote-batch'}}. Items that cannot be linked to a support request are hidden from this list, so fewer rows may be shown.",
      'Tooltip: Explains the group count includes items hidden from the link-items selector'
    );
    register.add(
      Id.defaultBatch,
      'Default',
      "Badge: this {{glossary 'quote-batch'}} is the catch-all new items go into"
    );
    register.add(
      Id.defaultBatchTooltip,
      "New items are added to this {{glossary 'quote-batch'}} unless you move them into another one.",
      'Tooltip: explains what the Default badge on the primary group means'
    );
    register.add(Id.excludedFromPricing, 'Excluded from pricing', 'Badge/tooltip: Group excluded from pricing');
    register.add(Id.groupName, "{{glossary 'quote-batch'}} Name", 'Field: Group name');
    register.add(Id.excludeFromPricing, 'Exclude from Pricing', 'Field: Exclude group from pricing');
    register.add(
      Id.excludeFromPricingTooltip,
      "{{glossary 'quote-item:plural'}} in this {{glossary 'quote-batch'}} will not be included in pricing, will not be added to the {{glossary 'purchase-order'}}, and will not be part of any generated customer reports.",
      'Tooltip: Exclude group from pricing explanation'
    );
    register.add(Id.groupDefaultName, "{{glossary 'quote-batch'}} {{number}}", 'Default name for a new group');
    register.add(
      Id.groupNameRequired,
      "{{glossary 'quote-batch'}} Name is required",
      'Validation: Group name is required'
    );
    // "Delivery", not "Delivery Date": every use sits against a date value or a date picker, so the word
    // adds nothing. Matches the label the purchase order and the reports use.
    register.add(Id.batchDeliveryDate, 'Delivery', 'Field: Batch (delivery group) required delivery date');
    register.add(
      Id.batchDeliveryDateTooltip,
      "The required delivery date for this {{glossary 'quote-batch'}}. A {{glossary 'quote'}} can be split into multiple {{glossary 'quote-batch:plural'}}, each shipped on its own date. Leave it blank and this {{glossary 'quote-batch'}} uses the {{glossary 'quote'}}'s delivery date.",
      'Tooltip: Batch delivery date explanation, including the inherit-when-blank default'
    );
    register.add(Id.batchCustomerRef, 'Customer Reference', 'Field: Batch customer reference');
    register.add(Id.batchComment, 'Delivery Comment', 'Field: Batch delivery comment');
    register.add(
      Id.pricingUnavailable,
      'Deferred',
      'Badge shown in place of an SSI price while pricing is deferred/out of date'
    );
    register.add(
      Id.pricingUnavailableTooltip,
      "Priced per {{glossary 'quote-batch'}}. The {{glossary 'quote-batch:plural'}} changed — use Update Price to recalculate.",
      'Tooltip: why a supplier charge shows the Deferred badge instead of a price'
    );
  }
}
